import {fsa, fsaPayload, fsaError} from './helpers'

// Fit
// ----------------------------------------------------------------------------

export const ENTER_FIT_FLOW = 'entering the fit flow'
export const enterFitFlow = fsa(ENTER_FIT_FLOW)

export const LEAVE_FIT_FLOW = 'leaving the fit flow'
export const leaveFitFlow = fsa(LEAVE_FIT_FLOW)

// Start
// ----------------------------------------------------------------------------

export const START = 'start the fit survey'
export const start = fsa(START)

// Curr & On Deck Step
// ----------------------------------------------------------------------------

export const SET_CURR_STEP = 'set the current step'
export const setCurrStep = fsaPayload(SET_CURR_STEP)

export const SET_ON_DECK_STEP = 'set the on deck step'
export const setOnDeckStep = fsaPayload(SET_ON_DECK_STEP)

export const SET_ON_DECK_STEP_FAILURE = 'failure to set the on deck step'
export const setOnDeckStepFailure = fsaError(SET_ON_DECK_STEP_FAILURE)

export const RECORD_SURVEY_INPUT_VALIDATION_FAILURE = 'record a survey input validation failure'
export const recordSurveyInputValidationFailure = fsaPayload(RECORD_SURVEY_INPUT_VALIDATION_FAILURE)

export const SUBMIT_STEP = 'submit a survey step'
export const submitStep = (step, source) => ({
  payload: {step, source},
  type: SUBMIT_STEP,
})

export const SUBMIT_CURR_STEP_AND_CALCULATE = 'submit the current survey step and calculate sizes'
export const submitCurrStepAndCalculate = fsa(SUBMIT_CURR_STEP_AND_CALCULATE)

// Input & Response
// ----------------------------------------------------------------------------

export const RECORD_STEP_INPUT = 'record a step input'
export const recordStepInput = (id, value) => ({
  payload: {id, value},
  type: RECORD_STEP_INPUT,
})

export const RECORD_STEP_RESPONSE = 'record a step response'
export const recordStepResponse = (id, value) => ({
  payload: {id, value},
  type: RECORD_STEP_RESPONSE,
})

// Calculate
// ----------------------------------------------------------------------------

export const CALCULATE = 'calculate sizes from survey responses'
export const calculate = fsa(CALCULATE)

export const CALCULATE_PENDING = 'calculate sizes pending'
export const calculatePending = fsa(CALCULATE_PENDING)

export const CALCULATE_PRE_SUCCESS = 'calculate sizes pre-success'
export const calculatePreSuccess = fsa(CALCULATE_PRE_SUCCESS)

export const CALCULATE_FAILURE = 'calculate sizes failure'
export const calculateFailure = fsaError(CALCULATE_FAILURE)

export const CALCULATE_SUCCESS = 'calculate sizes success'
export const calculateSuccess = fsa(CALCULATE_SUCCESS)

// Sizes
// ----------------------------------------------------------------------------

export const RECORD_SIZE_INPUT = 'record a size input'
export const recordSizeInput = (id, value) => ({
  payload: {id, value},
  type: RECORD_SIZE_INPUT,
})

export const CANCEL_SIZES = 'cancel editing recommended sizes'
export const cancelSizes = fsa(CANCEL_SIZES)

export const EDIT_SIZES = 'edit recommended sizes'
export const editSizes = fsaPayload(EDIT_SIZES)

export const EDIT_SIZES_FAILURE = 'failed to edit recommended sizes'
export const editSizesFailure = fsaError(EDIT_SIZES_FAILURE)

// Modal
// ----------------------------------------------------------------------------

export const DISPLAY_ERROR = 'display a fit flow error'
export const displayError = fsaPayload(DISPLAY_ERROR)

export const DISPLAY_INFO = 'display information modal in fit flow'
export const displayInfo = fsaPayload(DISPLAY_INFO)

export const HIDE_ERROR = 'hide error in fit flow'
export const hideError = fsa(HIDE_ERROR)

export const HIDE_INFO = 'hide information modal in fit flow'
export const hideInfo = fsa(HIDE_INFO)
